
export const getSiblings = (el) => Array.from(el.parentNode.children).filter((ch) => ch !== el);
